import Vue from 'vue';

Vue.filter('formal', (value: string) => {
  if (value) {
    return 'Sie';
  }

  return 'Du';
});
